import { useState, useEffect } from 'react';

// Singleton: one resize listener shared across all consumers
const listeners = new Set<(v: boolean) => void>();
let currentIsMobile = window.innerWidth <= 768;

window.addEventListener('resize', () => {
    const next = window.innerWidth <= 768;
    if (next !== currentIsMobile) {
        currentIsMobile = next;
        listeners.forEach(l => l(next));
    }
}, { passive: true });

export const useIsMobile = () => {
    const [isMobile, setIsMobile] = useState(currentIsMobile);

    useEffect(() => {
        listeners.add(setIsMobile);
        return () => { listeners.delete(setIsMobile); };
    }, []);

    return isMobile;
};
